import { render } from "./TrafficLightSection.vue?vue&type=template&id=56170e96&scoped=true"
import script from "./TrafficLightSection.vue?vue&type=script&lang=js"
export * from "./TrafficLightSection.vue?vue&type=script&lang=js"

import "./TrafficLightSection.vue?vue&type=style&index=0&id=56170e96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56170e96"]])

export default __exports__